import { render, staticRenderFns } from "./EmptyCom.vue?vue&type=template&id=cde29eea&scoped=true&"
import script from "./EmptyCom.vue?vue&type=script&lang=js&"
export * from "./EmptyCom.vue?vue&type=script&lang=js&"
import style0 from "./EmptyCom.vue?vue&type=style&index=0&id=cde29eea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cde29eea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cde29eea')) {
      api.createRecord('cde29eea', component.options)
    } else {
      api.reload('cde29eea', component.options)
    }
    module.hot.accept("./EmptyCom.vue?vue&type=template&id=cde29eea&scoped=true&", function () {
      api.rerender('cde29eea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DesignEditor/component/panel/EmptyCom.vue"
export default component.exports